import { FC } from 'react';
import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { AmountCellViewModel } from './viewModel';

type AmountCellProps = GridRenderCellParams<AmountCellViewModel>;

export const AmountCell: FC<AmountCellProps> = ({ value: viewModel }) => {
  return <Typography variant="subtitle2">{viewModel?.cellValue}</Typography>;
};
